export const FLOATING_PROMOTION_BANNER_IMAGES = {
  ARROW_UP: 'https://cf.image-farm.s.zigzag.kr/original/cms/2026/02/03/202602030300044940_022175.png',
} as const;
